import React, { useState } from 'react';
import { useBrand } from '../context/BrandContext';

interface Props {
  size?: number;
  showTagline?: boolean;
  /** Use the square mark (pizza slice only) instead of the full wordmark. */
  mark?: boolean;
}

const BrandLogo: React.FC<Props> = ({ size = 40, mark = false }) => {
  const { brand } = useBrand();
  const [imgError, setImgError] = useState(false);

  // SVG is lighter and renders crisp at any size.
  const src = brand.id === 'donvito'
    ? (mark ? '/donvito_mark.svg?v=2' : '/donvito_logo.svg?v=2')
    : brand.logo;

  if (src && !imgError) {
    return (
      <img
        src={src}
        alt={brand.name}
        style={{ height: size, width: 'auto', objectFit: 'contain' }}
        onError={() => setImgError(true)}
      />
    );
  }

  const fontSize = Math.round(size * 0.65);
  return (
    <div className="brand-wordmark" style={{ fontSize }}>
      {brand.shortName}
    </div>
  );
};

export default BrandLogo;
